import { Box, Container, Link, Typography } from '@mui/material';
import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 2, mb: 1 }}>
          <Link href="/privacy" color="inherit" sx={{ textDecoration: 'none' }}>
            Privacy Policy
          </Link>
          <Link href="/terms" color="inherit" sx={{ textDecoration: 'none' }}>
            Terms of Service
          </Link>
          <Link
            href="#"
            color="inherit"
            sx={{ textDecoration: 'none' }}
            onClick={(e) => {
              e.preventDefault();
              window.dispatchEvent(new Event('openCookieSettings'));
            }}
          >
            Cookie Settings
          </Link>
        </Box>
        <Typography variant="body2" color="text.secondary" align="center">
          {`© ${currentYear} Conformity Core. All Rights Reserved.`}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
